import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { now } from 'moment';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import {  Turno } from 'src/app/models/dash';
import { RetiroService } from 'src/app/services/retiro.service';
import { AppState } from 'src/app/state/app.state';
import { selectRetiroPrint } from 'src/app/state/selectors/retiro.selectors';
import { selectUser } from 'src/app/state/selectors/user.selectors';
import { EventEmitter } from 'stream';
import { getTurno } from '../../../app/utils/index';
@Component({
  selector: 'app-print-formato-final',
  templateUrl: './print-formato-final.component.html',
  styleUrls: ['./print-formato-final.component.scss']
})
export class PrintFormatoFinalComponent implements OnInit {
  user: any;
  dateTime = now();
  tipoImpresion: string = "[ IMPRESION ]";
  turnoActual: Turno;

  @Input () cortes: any;
  @Input () totales: any;

  constructor(
    private store: Store<AppState>,
    private router: Router,
    private toastr: ToastrService,
    private ngxUiLoaderService: NgxUiLoaderService,
  ) { }

  ngOnInit(): void {
    //redux
    this.store.select(selectUser).subscribe(async (user) => {
      this.user = user;
      console.log(this.user);

    });
    this.turnoActual=getTurno();

    console.log(this.turnoActual);

    console.log(this.cortes);
    console.log(this.totales);

  }


  imprent() {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Ticket</title>
          <link rel="stylesheet" href="/styles.css">
        </head>
    <body onload="window.print();window.close()"><center style="margin: 5mm;">${printContents}</center></body>
      </html>`
    );
    popupWin.document.close();
    window.location.reload()
  }
}
